module.exports = __webpack_public_path__ + "img/new.20a9de44.svg";